// extracted by mini-css-extract-plugin
export var modal = "_ul-0";
export var table = "_ul-1";